import React from 'react';
import Form from 'react-bootstrap/Form';
import MASpinner from '../../common/MASpinner';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { renderCheckbox, renderField } from '../../../lib/helper/form';

const mapStateToProps = (state) => ({
  ...state.hospitals,
  initialValues: {
    useAutomatedChasing: true,
  },
});

class HospitalCreateForm extends React.Component {
  onSubmit = async (values) => {
    const { onCreate, reset } = this.props;

    try {
      await onCreate({
        name: values.name,
        useAutomatedChasing: values.useAutomatedChasing,
      });
      reset();
    } catch (error) {
      throw error;
    }
  };

  render() {
    const { handleSubmit, error, pristine, submitting, isCreatingHospital, reset } = this.props;

    return (
      <div className="crud__section mb-3">
        <div className="crud__section-icon">
          <i className="fas fa-hospital" />
        </div>
        <h2 className="crud__section-header">Hospital Details</h2>

        {error && <div className="alert alert-danger">{error}</div>}

        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Field className="mb-3" name="name" label="Hospital Name" id="name" type="text" component={renderField} required />

          <Field name="useAutomatedChasing" label="Use Automated Invoice Chasing?" id="use-automated-chasing" component={renderCheckbox} />
          <br />

          {isCreatingHospital ? (
            <MASpinner msg="Creating hospital..." />
          ) : (
            <div>
              <button type="submit" disabled={pristine || submitting} className="btn btn-primary mr-2">
                Create Hospital
              </button>
              <button type="button" onClick={reset} disabled={submitting} className="btn btn-secondary">
                Clear
              </button>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  null,
)(
  reduxForm({
    form: 'HospitalCreateForm',
    enableReinitialize: true,
  })(HospitalCreateForm),
);
